"use client";
import AutoScroll from "embla-carousel-auto-scroll";
import useEmblaCarousel from "embla-carousel-react";
import { useLocale } from "next-intl";
import Image from "next/image";
import { useEffect, useState } from "react";

const heroSliderData = {
  en: [
    { id: 1, imageUrl: "/images/cover1_sm.avif" },
    { id: 2, imageUrl: "/images/cover1_ai_sm.avif" },
    { id: 3, imageUrl: "/images/cover2_sm.avif" },
    { id: 4, imageUrl: "/images/cover2_ai_sm.avif" },
    { id: 5, imageUrl: "/images/cover5_sm.avif" },
    { id: 6, imageUrl: "/images/cover3_ai_sm.avif" },
    { id: 7, imageUrl: "/images/cover6_sm.avif" },
    { id: 8, imageUrl: "/images/cover8_sm.avif" },
  ],
  "es-us": [
    { id: 1, imageUrl: "/images/es-us/cover1_sm.avif" },
    { id: 2, imageUrl: "/images/es-us/cover1_ai_sm.avif" },
    { id: 3, imageUrl: "/images/es-us/cover2_sm.avif" },
    { id: 4, imageUrl: "/images/es-us/cover2_ai_sm.avif" },
    { id: 5, imageUrl: "/images/es-us/cover5_sm.avif" },
    { id: 6, imageUrl: "/images/es-us/cover3_ai_sm.avif" },
    { id: 7, imageUrl: "/images/es-us/cover6_sm.avif" },
    { id: 8, imageUrl: "/images/es-us/cover8_sm.avif" },
  ],
};

export default function HeroMarqueeEmblaContinuous({
  speed = 0.6,
  gapPx = 15,
  slidesPerView = 2.4,
  direction = "forward",
}) {
  const locale = useLocale();
  const [isMounted, setIsMounted] = useState(false);

  const options = {
    loop: true,
    align: "start",
    containScroll: true,
    dragFree: true,
    draggable: false,
  };

  const autoScrollOptions = {
    playOnInit: true,
    stopOnInteraction: false,
    stopOnMouseEnter: false,
    speed: speed,
    direction: direction,
  };

  const [viewportRef, emblaApi] = useEmblaCarousel(options, [
    AutoScroll(autoScrollOptions)
  ]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!emblaApi) return;
    const autoScroll = emblaApi?.plugins()?.autoScroll;
    if (autoScroll) {
      autoScroll.play();
    }
  }, [emblaApi]);


  const slides = heroSliderData[locale] || heroSliderData.en;

  if (!isMounted) {
    return (
      <div className="h-[235px] overflow-hidden flex items-center text-[#2B2B2BE0]">
        <div className="w-full px-4">
          <div className="flex justify-center items-center gap-2.5 h-full">
            {slides.slice(0, 3).map((slide) => (
              <div key={slide.id} className="flex-shrink-0">
                <Image
                  src={slide.imageUrl}
                  alt={`Book Cover ${slide.id}`}
                  width={170}
                  height={233}
                  priority
                  className="h-auto block"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const slideBasis = `calc((100% - ${(slidesPerView - 1) * gapPx}px) / ${slidesPerView})`;

  return (
    <div className="embla" aria-label="Books marquee">
      <div className="embla__viewport" ref={viewportRef}>
        <div className="embla__container" style={{ gap: `${gapPx}px` }}>
          {slides.map((slide) => (
            <div
              className="embla__slide"
              style={{
                flexBasis: slideBasis,
                marginRight: slide.id === 8 ? gapPx : 0
              }}
              key={slide.id}
            >
              <Image
                src={slide.imageUrl}
                alt={`Book Cover ${slide.id}`}
                width={170}
                height={233}
                className="embla__img"
                priority
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}